import styled from 'styled-components'

export const Container = styled.div`
  display: flex;

  width: 100%;
  flex-direction: column;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  margin-bottom: 40px;
  max-width: 500px;
`

export const ItemContent = styled.div`
  padding: 20px 0 20px 0;
`
